

import React from 'react'

const styles={
    margin: '30px 0 0 0',
    borderTop: '1px solid #aeb0b5',
}

const Divider = () => (
    <div style={styles}/>
)

export default Divider